import React from "react";
import { X, Maximize2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useConciergeWidget } from "@/utils/hooks/useConciergeWidget";
import { useConciergeContext } from "./ConciergeContextProvider";

export const ConciergeWidgetHeader: React.FC = () => {
  const { closeWidget } = useConciergeWidget();
  const navigate = useNavigate();
  const { conversationId } = useConciergeContext();

  const handleExpand = () => {
    // Navigate to full concierge page with conversation ID if exists
    // Preserve brandId and appConfigId from URL
    const params = new URLSearchParams(window.location.search);
    const brandId = params.get("brandId");
    const appConfigId = params.get("appConfigId");

    const queryParams = new URLSearchParams();
    if (conversationId) queryParams.set("conversationId", conversationId);
    if (brandId) queryParams.set("brandId", brandId);
    if (appConfigId) queryParams.set("appConfigId", appConfigId);

    const path = `/concierge${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
    closeWidget();
    navigate(path);
  };

  return (
    <div className="tw:flex tw:items-center tw:justify-between tw:p-4 tw:border-b tw:border-gray-200 tw:bg-white">
      <h2 className="tw:text-lg tw:font-semibold tw:text-gray-900">
        Concierge
      </h2>
      <div className="tw:flex tw:items-center tw:gap-2">
        <button
          onClick={handleExpand}
          className="tw:p-2 tw:rounded-lg tw:text-gray-600 hover:tw:bg-gray-100 tw:transition-colors"
          aria-label="Expand to full page"
        >
          <Maximize2 className="tw:w-5 tw:h-5" />
        </button>
        <button
          onClick={closeWidget}
          className="tw:p-2 tw:rounded-lg tw:text-gray-600 hover:tw:bg-gray-100 tw:transition-colors"
          aria-label="Close"
        >
          <X className="tw:w-5 tw:h-5" />
        </button>
      </div>
    </div>
  );
};
